export default {
    title: 'Edit innovation field',
    pageTitle: 'EDIT - INNOVATION FIELD',

    feedback: {
        success: 'The innovation field "{title}" was successfully updated.'
    }
}
